import { enUS as dateFnsEnUS } from 'date-fns/locale/en-US'
import { sv as dateFnsSv } from 'date-fns/locale/sv'
import { enUS as muiGridEnUS, svSE as muiGridSvSE } from '@mui/x-data-grid-pro/locales'
import { useTranslation } from 'react-i18next'
import { resolveLanguage } from './languagePreference'

export function getIntlLocale(language: string | null | undefined): string {
    return resolveLanguage(language) === 'sv' ? 'sv-SE' : 'en-US'
}

export type IntlDateLocale = 'sv-SE' | 'en-US'

/** Display dates in locale order; English uses MM/DD/YYYY (en-US). */
export function getIntlDateLocale(language: string | null | undefined): IntlDateLocale {
    return resolveLanguage(language) === 'sv' ? 'sv-SE' : 'en-US'
}

export function getSortLocale(language: string | null | undefined): string {
    return getIntlLocale(language)
}

export function getDateFnsLocale(language: string | null | undefined) {
    return resolveLanguage(language) === 'sv' ? dateFnsSv : dateFnsEnUS
}

export function getMuiDataGridLocaleText(language: string | null | undefined, overrides?: Record<string, string>) {
    const locale = resolveLanguage(language)
    const base =
        locale === 'sv'
            ? muiGridSvSE.components.MuiDataGrid.defaultProps.localeText
            : muiGridEnUS.components.MuiDataGrid.defaultProps.localeText

    return overrides ? { ...base, ...overrides } : base
}

export function useAppLocale() {
    const { i18n } = useTranslation()
    const language = resolveLanguage(i18n.resolvedLanguage ?? i18n.language)

    return {
        language,
        intlLocale: getIntlLocale(language),
        intlDateLocale: getIntlDateLocale(language),
        sortLocale: getSortLocale(language),
        dateFnsLocale: getDateFnsLocale(language),
        muiDataGridLocaleText: getMuiDataGridLocaleText(language),
    }
}
